import React, { useContext, useEffect, useState } from 'react'
import Application from "../../StateContext/Application";
const Report = () => {
    const statecalls = useContext(Application);
    const { GetReport } = statecalls;
    const [reportData, SetReportData] = useState([]);

    useEffect(() => {
        AllReportData();
    }, []);

    async function AllReportData() {
        try {
            let data = await GetReport();
            console.log(data);
            
            SetReportData(data);
        } catch (error) {
            console.error(error);
        }
    }
    return (
        <div>
           <div style={{display:"flex",justifyContent:"center"}}>
           <h3>Report</h3>
           </div>

            <div style={{ padding: "50px" }}>
                <table className="table table-striped table-bordered">
                    <thead className="table-primary">
                        <tr>
                            <th>Sr.no.</th>
                            <th>Date</th>
                            <th>Description</th>
                            <th>Cheque No.</th>
                            <th>Debit</th>
                            <th>Credit</th>
                            <th>Balance</th>
                        </tr>
                    </thead>
                    <tbody>
                        {reportData &&
                            reportData.map((e, index) => {
                                return (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{e.Date?.split('.')[0].replace('T', ' ')}</td>
                                        <td>{e.Description}</td>
                                        <td>{e.Cheque_No==null?"--":e.Cheque_No}</td>
                                        <td>{e.Debit==null?"--":e.Debit}</td>
                                        <td>{e.Credit==null?"--":e.Credit}</td>
                                        <td>{e.Balance}</td>
                                        
                                    </tr>
                                );
                            })}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default Report
